module["exports"] = [
  "#{street_name}#{building_number}號"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/zh_TW/address/street_address.js
 ** module id = 1129
 ** module chunks = 0
 **/